package modysy.model

import modysy.simulation.pp.State
import modysy.view.ImageProvider
import org.scalajs.dom

/** Abstract class that models all game objects that exist in the game.
  *
  * @param body The rigid body of the object, containing position, velocity, material and geometry information.
  */
abstract class GameObject(val body: RigidBody) {
  type Ctx2D = dom.CanvasRenderingContext2D

  def color: String

  /** Reaction to resolved collision with another object. */
  def onCollision(other: GameObject): Unit = {}

  /** Reaction to the passed time.
    *
    * @param timePassed Time in seconds.
    */
  def onTimePassed(timePassed: Double): Unit = {}

  /** Returns whether the gameObject is alive - if it's not it should be removed from the field.
    */
  def alive: Boolean = true

  /** Renders a given GameObject by the given geometry information.
    *
    * A prior call to setupCanvas of the Render class is required to obtain
    * access to the canvas rendering context (ctx).
    *
    * @param ctx Canvas Rendering Context
    */
  def render(ctx: Ctx2D): Unit = {
    body.geometry match {
      case Circle(radius) =>
        //ctx.fillStyle = agent.state.deducedAgentColor
        ctx.fillStyle = color
        //ctx.strokeStyle = agent.state.deducedAgentColor

        ctx.beginPath()
        ctx.arc(
          body.pose.translation.x,
          body.pose.translation.y,
          radius,
          0,
          2 * Math.PI
        )
        //ctx.stroke()
        ctx.closePath()
        ctx.fill()

        if (this.isInstanceOf[Agent]) {
          var imgUrl: String = "agent"
          if (!this.asInstanceOf[Agent].behaviour_active)
            imgUrl = "agentSleep"
          ImageProvider
            .drawImgFnc(ImageProvider.getImage(imgUrl), 110, 172)
            .apply(
              ctx,
              body.pose.translation.x - (110 / 2),
              body.pose.translation.y - (172 / 2)
            )
        }
      case Box(width, height) =>
        ctx.fillStyle = color

        var tx = body.pose.translation.x
        var ty = body.pose.translation.y

        ctx.save()
        ctx.translate(tx, ty)
        ctx.rotate(body.pose.orientation)
        ctx.translate(-tx, -ty)
        var posx = tx - 0.5 * width
        var posy = ty - 0.5 * height

        if (this.isInstanceOf[Obstacle]) {
          ImageProvider
            .drawImgFnc(ImageProvider.getImage("box"), 100, 100)
            .apply(ctx, posx, posy)
        } else {
          ctx.fillRect(posx, posy, width, height)
        }

        ctx.restore()

      case _ => println("Cannot render this GameObject")
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/GameObject.scala